<template>
  <div>
    <v-select style="width: 180px;"
              :data="typeOptions"
              :allowClear="false"
              @change="changeApp"
              disabled
              v-model="typeValue"></v-select>
    <v-input placeholder="请输入信息进行查询"
             v-model="valueId"
             style="width:200px;display:inline-block"></v-input>
    <v-button type="primary"
              @click="handleSearch">查询</v-button>
    <div class="tips">
      <div class="tips-content">
        <div class="tips-content-bar"></div>
        <div>
          <p style="color: #888888;font-size: 12px !important;" >账户余额</p>
          <p style="color: #49a9ee;font-size: 20px !important;">{{`${(this.userInfo.balance/100).toFixed(2)}`}}</p>
        </div>
      </div>
      <div class="tips-content">
        <div class="tips-content-bar"></div>
        <div>
          <p style="color: #888888;font-size: 12px !important;" >累计充值</p>
          <p style="color: #49a9ee;font-size: 20px !important;">{{`${(this.userInfo.fee/100).toFixed(2)}`}}</p>
        </div>
      </div>
      <div class="tips-content">
        <div class="tips-content-bar"></div>
        <div>
          <p style="color: #888888;font-size: 12px !important;" >累计赠送</p>
          <p style="color: #49a9ee;font-size: 20px !important;">{{`${((this.userInfo.value-this.userInfo.fee)/100).toFixed(2)}`}}</p>
        </div>
      </div>
    </div>
    <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="order_id"
                       width="200px"
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="payment_time"
                       width="160px"
                       label="订单时间">
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.payment_time)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state"
                       width="120px"
                       label="订单状态">
        <template slot-scope="scope">
          <span>{{stateOptions.filter((item)=>{return item.value==scope.row.state})[0].label}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="user_id"
                       width="160px"
                       label="用户ID">
      </el-table-column>
      <el-table-column prop="nickname"
                       width="100px"
                       label="用户昵称">
      </el-table-column>
      <el-table-column prop="fee"
                       width="90px"
                       label="实际支付">
        <template slot-scope="scope">
          <span>{{`${scope.row.fee/100}元`}}</span>
        </template>
      </el-table-column>
      <el-table-column prop=""
                       width="90px"
                       label="赠送金额">
        <template slot-scope="scope">
          <span>{{`${(scope.row.value-scope.row.fee)/100}元`}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invoice_id"
                       width="80px"
                       label="实际到账">
        <template slot-scope="scope">
          <span>{{`${scope.row.value/100}元`}}</span>
        </template>
      </el-table-column>
      <el-table-column width="80px" label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     v-if="scope.row.is_mark_refund"
                     @click="handleRefundMark(scope.row)"
                     size="small">标记退款</el-button>
          <el-button type="text"
                     v-if="scope.row.is_refund"
                     @click="confirmRefund(scope.row)"
                     size="small">退款</el-button>
          <span v-show="!scope.row.is_mark_refund&&!scope.row.is_refund">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       width="160px"
                       label="备注">
        <template slot-scope="scope">
          <p :key="item" v-for="item in scope.row.remark">{{item}}</p>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next"
      style="float: right"
      :current-page="pageNum"
      @current-change="handleCurrentChange"
      :page-size="5"
      :total="total">
    </el-pagination>
    <v-modal title="填写退款信息"
             :visible="refundVisible"
             @ok="confirmRefundMark"
             @cancel="refundVisible=false">
      <el-row style="margin: 10px 0px">
        <el-col :offset="2" :span="4">
          <span>退款金额</span>
        </el-col>
        <el-col :span="15">
          <v-input-number style="width: 300px" v-model="refundAmount"></v-input-number>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0px">
        <el-col :offset="1" :span="5">
          <span>修改账户余额</span>
        </el-col>
        <el-col :span="15">
          <v-input-number style="width: 300px" v-model="balanceAmount"></v-input-number>
        </el-col>
      </el-row>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      userInfo: {},
      valueId: '',
      refundVisible: false,
      detailInfo: {},
      typeOptions: [{value: 0, label: '用户ID'}, {value: 1, label: '充值订单编号'}],
      stateOptions: [
        {value: 1, label: '已支付'},
        {value: 2, label: '未支付'},
        {value: 3, label: '已删除'},
        {value: 4, label: '已退款并删除'},
        {value: 5, label: '标记退款并删除'}
      ],
      typeValue: 1,
      tableData: [],
      refundAmount: '',
      balanceAmount: '',
      total: 0,
      pageNum: 1,
      pageSize: 5,
      axiosLastUrl: ''
    }
  },
  methods: {
    formatDate (time) {
      const date = new Date(time)
      const YY = date.getFullYear() + '-'
      const MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      const hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      const mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      const ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      return YY + MM + DD + ' ' + hh + mm + ss
    },
    handleRefundMark (item) {
      this.detailInfo = item
      this.refundVisible = true
    },
    confirmRefund (item) {
      this.detailInfo = item
      let url = `/dev/refund/balance/${this.detailInfo.order_id}`
      axios.post(url)
        .then(res => {
          this.refundVisible = false
          if (res.data.code === 200) {
            this.$message({
              message: '退款成功',
              type: 'success'
            })
            this.handleRefresh(this.axiosLastUrl)
          }
        })
    },
    confirmRefundMark () {
      let url = `/dev/mark_refund/balance/${this.detailInfo.order_id}`
      axios.post(url, {refund_fee: Number(this.refundAmount) * 100, balance: Number(this.balanceAmount) * 100})
        .then(res => {
          this.refundVisible = false
          if (res.data.code === 200) {
            this.$message({
              message: '标记退款成功',
              type: 'success'
            })
            this.handleRefresh(this.axiosLastUrl)
          }
        })
    },
    handleRefresh (url) {
      axios.get(url)
        .then(res => {
          let arr = []
          arr = res.data.result ? res.data.result : [res.data.order]
          this.total = res.data.count ? res.data.count : arr.length
          this.tableData = arr
        })
    },
    changeApp () {
      console.log()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.searchReCharge()
    },
    handleSearch () {
      if (this.valueId === '') {
        this.$message({
          message: '请输入查询条件',
          type: 'warning'
        })
        return
      }
      this.searchByOrderId()
    },
    searchReCharge () {
      this.userInfo = this.$route.query
      console.log(this.$route.query)
      let url = `/dev/paid_offer/${this.userInfo.user_id}/balance/order`
      url = url + '?limit=' + this.pageSize + '&page=' + `${this.pageNum - 1}`
      axios.get(url)
        .then(res => {
          let arr = []
          arr = res.data.result
          this.total = res.data.count
          this.tableData = arr
          this.axiosLastUrl = url
        })
    },
    searchByOrderId () {
      let url = `/dev/paid_offer/order/${this.valueId}`
      url = url + '?paid_group=balance'
      axios.get(url)
        .then(res => {
          let arr = []
          arr = [res.data.order]
          this.total = arr.length
          this.tableData = arr
          this.axiosLastUrl = url
        })
    }
  },
  created () {
    this.searchReCharge()
  }
}
</script>

<style scoped>
  .tips{
    width:70%;
    display: flex;
    justify-content: space-between
  }
  .tips-content {
    background-color: #FFFFFF;
    box-shadow: 0px 0px 10px #aaaaaa;
    width: 25%;
    height: 80px;
    display: flex;
    align-items: center;
    margin: 30px 0px;
  }
  .tips-content-bar{
    width: 5px;
    height: 80px;
    background-color: #49a9ee;
    margin-right: 20px;
  }

  #self-modal{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/recharge/rechargeRecord.vue